import React from 'react'
import { Paper } from '@mui/material';

import SEO from "../components/SEO";

import { Box } from '@mui/system';

import { ReactComponent as Logo } from "../assets/svg/logo.svg";

import useMediaQuery from '@mui/material/useMediaQuery';




export default function LoadingPage() {
    const matches = useMediaQuery((theme) => theme.breakpoints.up('sm'));
    const style = {
        background: {
            //backgroundImage: `linear-gradient(transparent, white 50%), url(${background})`,
            paddingLeft: 2,
            paddingRight: 2,
            borderRadius: 0,
            paddingBottom: 0,
            paddingTop: 5,
            '@media only screen and (max-width: 900px)': {
                paddingTop: 2
            }
        },
        body: {
            '@media only screen and (min-width: 480px)': {
                marginLeft: '2%',
                marginRight: '2%',
            },
            '@media only screen and (min-width: 1700px)': {
                marginLeft: '10%',
                marginRight: '10%',
            },
        },
        typography: {
            fontWeight: "bold",
            opacity: 0.7,
            textAlign: "center",
            paddingBottom: 1,
            '@media only screen and (max-width: 900px)': {
                paddingBottom: 0,
                fontSize: 35,
                textAlign: "center"
            }
        },
        bodyText: {
            paddingBottom: 4,
            marginTop: 0,
            letterSpacing: 1,
            textAlign: "center",
            opacity: 0.7,
            '@media only screen and (max-width: 900px)': {
                paddingBottom: 0,
                marginTop: 2,
            }
        },
        contactButton: {
            maxWidth: 250,
            marginTop: 4,
            marginBottom: 4,
            paddingLeft: 10,
            color: (theme) => theme.palette.common.black,
            paddingTop: 1,
            textTransform: "none",
            paddingBottom: 1,
            paddingRight: 10,
            fontSize: 15,
            borderRadius: 7,
            boxShadow: 0,
            border: "2px black solid",
            "&:hover": {
                border: "2px solid",
                borderColor: (theme) => theme.palette.primary.main,
                color: (theme) => theme.palette.primary.main,
                opacity: 1,
            },
        },
        centerDiv: {
            marginTop: "5%",
            textAlign: "center"

        },
        memojiCenter: {
            display: "flex",
            '@media screen and (min-width: 900px)': {
                display: "none"
            }
        },
        memojiLeft: {
            '@media screen and (max-width: 900px)': {
                display: "none"
            }
        },
        cardMedia: {
            borderRadius: 0,
            minWidth: 200,
            '@media screen and (min-width: 900px)': {
                height: "100%",
            }
        },
        linkText: {
            fontStyle: "italic",
            fontWeight: "bold",
            color: (theme) => theme.palette.primary.main
        },
        textField: {
            minWidth: matches ? 400 : 300,
            '& label.Mui-focused': {
                color: (theme) => theme.palette.primary.main,
            },
            '& .MuiOutlinedInput-root': {
                fontStyle: "italic",
                borderRadius: 7,
                '&.Mui-focused fieldset': {
                    border: "3px black solid",
                },
            },
        },
        cardMediaLarge: {
            borderRadius: 0,
            '@media screen and (min-width: 900px)': {
                height: "100%",
            }
        },
        footerStyle: {
            position: "fixed",
            left: 0,
            bottom: 0,
            width: "100%",
            textAlign: "center"
        },
        loginAlternative: {
            padding: 0,
            height: 90,
            width: 90
        }
    }
  
    return (
        <Box>
            <SEO title="Loading..." description="RANIELLA VILLARAMA WEB DEVELOPER PORTFOLIO ... About" />
            <Paper sx={style.background} elevation={0}>
                <Box sx={style.body}>
                    <Box display="flex" m="auto" sx={{ justifyContent: "center" }}>
                        <Logo style={{ marginTop: "20%" }} />
                    </Box>
                </Box>
            </Paper>
        </Box>
    )
}
